import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/Card/card';
import { FlowBoard, READ_ONLY_FLOW_BOARD_CONFIG } from '@/components/FlowNode';
import { VStack } from '@/components/Layout';
import { Text } from '@/components/Typography/Text';
import { Button } from '@/components/ui/button';
import { toast } from '@/components/ui/use-toast';
import { handleApiError } from '@/lib/api/error';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { ApprovalSubmitTaskContent } from '../-components/approval/ApprovalSubmitTaskContent';
import { convertApprovalFlowToFlowData, useApproveApplication, useGetApprovalTaskDetail } from './-query';
export const Route = createFileRoute('/_individual/individual/task/$id/approval/')({
  component: RouteComponent
});
function RouteComponent() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'individualPages.tasks.approvalDialog'
  });
  const {
    t: tAction
  } = useTranslation(defaultNS, {
    keyPrefix: 'common.action'
  });
  const {
    i18n
  } = useTranslation();
  const {
    id
  } = Route.useParams();
  const {
    data
  } = useGetApprovalTaskDetail(id);
  const navigate = Route.useNavigate();

  // 承認フローデータをFlowNodeData形式に変換
  const flowData = convertApprovalFlowToFlowData(data.approvalFlow);
  const handleNavigateBack = useCallback(() => {
    navigate({
      to: `/individual`
    });
  }, [navigate]);
  const {
    mutate: approveApplication,
    isPending
  } = useApproveApplication({
    onSuccess: () => {
      toast({
        description: t('approvalSuccess'),
        variant: 'default'
      });
      navigate({
        to: `/individual`
      });
    },
    onError: error => {
      const {
        message
      } = handleApiError(error, {
        language: i18n.language
      });
      toast({
        description: message,
        variant: 'destructive'
      });
    }
  });
  const handleSubmit = useCallback(() => {
    approveApplication({
      taskId: id
    });
  }, [approveApplication, id]);
  return <div className="p-6">
      <VStack className="gap-6">
        <Card>
          <CardHeader>
            <CardTitle>{data.approvalTaskCatalogName}</CardTitle>
          </CardHeader>
          <CardContent>
            <VStack className="gap-4">
              <div>
                <Text variant="labelLarge" className="mb-2">
                  {t('submitTaskContent')}
                </Text>
                <ApprovalSubmitTaskContent submitTaskForm={data.submitTaskForm} />
              </div>

              <div>
                <Text variant="labelLarge" className="mb-2">
                  {t('approvalFlow')}
                </Text>
                <div className="h-96 border rounded">
                  <FlowBoard data={flowData} config={READ_ONLY_FLOW_BOARD_CONFIG} className="w-full h-full" />
                </div>
              </div>

              <div className="flex justify-between pt-4">
                <Button variant="outline" onClick={handleNavigateBack}>
                  {tAction('cancel')}
                </Button>
                <Button onClick={handleSubmit} disabled={isPending}>
                  {isPending ? t('approving') : t('approve')}
                </Button>
              </div>
            </VStack>
          </CardContent>
        </Card>
      </VStack>
    </div>;
}